import React, { useEffect, useState } from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import Image from "next/image";

import convertHTMLtoJSX from "@/next-src/utils/convertHTMLtoJSX";

import comCSS from "./Button.module.scss";

const Button = ({
  data = {},
  className = "",
  onClick = () => {},
  type = "button",
  disabled = false,
  isPulsingIcon = false,
  isPhoneIcon = false,
  target = "",
  isArrowRight = false,
  isDownloadIcon = false,
}) => {
  const [cssHover, setCssHover] = useState("");
  const {
    id,
    text,
    btnTextBlack,
    bgColor,
    borderColor,
    hide,
    bgColorHover,
    borderColorHover,
  } = data || {};

  useEffect(() => {
    if (bgColorHover || borderColorHover) {
      setCssHover(`.button.btn-${id}-hover:hover {
            border-color: ${borderColorHover || ""} !important;
            background-color: ${bgColorHover || ""} !important;
          }
      `);
    }
  }, [bgColorHover, borderColorHover, setCssHover, id]);

  const attributes = {};
  if (target) attributes.target = target;

  if (hide || !text) return null;

  return (
    <button
      id={id}
      className={cn(className, "button w-inline-block", {
        [comCSS.blackText]: btnTextBlack,
        [`btn-${id}-hover`]: bgColorHover || borderColorHover,
      })}
      style={{
        backgroundColor: bgColor || "",
        borderColor: borderColor || "",
      }}
      onClick={onClick}
      {...attributes}
      type={type ? "submit" : "button"}
      disabled={disabled}
    >
      <style>{cssHover}</style>
      {isPhoneIcon ? (
        <Image
          width={16}
          height={16}
          src="/images/home/64b7b352b7162cc04b74c422_phone.svg"
          loading="lazy"
          alt=""
          className="icon-1x1-xxsmall"
        />
      ) : null}
      {isDownloadIcon ? (
        <Image
          width={24}
          height={24}
          src="/images/home/63db8e89e8a2c669e01bef4b_download-icon.svg"
          loading="lazy"
          alt=""
          className="icon-1x1-xsmall"
        />
      ) : null}
      {isPulsingIcon ? (
        <div className={cn(comCSS.btnMark, "pulsing-btn-dot-div")} />
      ) : null}
      <div>{convertHTMLtoJSX(text)}</div>
      {isArrowRight ? (
        <Image
          width={24}
          height={24}
          src="/images/home/63dbb4719a269f7433156259_arrow_forward_btn-black.svg"
          loading="lazy"
          alt=""
          className="icon-1x1-xsmall"
        />
      ) : null}
    </button>
  );
};

Button.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string,
    btnTextBlack: PropTypes.bool,
    url: PropTypes.string,
    bgColor: PropTypes.string,
    borderColor: PropTypes.string,
    hide: PropTypes.bool,
    enableShowMsgUs: PropTypes.bool,
    bgColorHover: PropTypes.string,
    borderColorHover: PropTypes.string,
  }),
  className: PropTypes.string,
  onClick: PropTypes.func,
  isPulsingIcon: PropTypes.bool,
  isPhoneIcon: PropTypes.bool,
};

export default Button;
